import React from "react"
import {FourSteps} from "./FourSteps"
import {cycleToWorkSteps} from "./constants"
import {Eligibility} from "./Eligibility"
import {FindABike} from "./FindABike"
import {Disclaimer} from "./Disclaimer"
import {PopularBikes} from "./PopularBikes"

export const CycleToWorkSection = () => {
  return (
    <>
      <PopularBikes />
      <FourSteps steps={cycleToWorkSteps} />
      <Eligibility />
      <FindABike />
      <Disclaimer />
    </>
  )
}
